import { render, staticRenderFns } from "./custom-column-modal.vue?vue&type=template&id=085dcd80"
import script from "./custom-column-modal.vue?vue&type=script&lang=js"
export * from "./custom-column-modal.vue?vue&type=script&lang=js"
import style0 from "./custom-column-modal.vue?vue&type=style&index=0&id=085dcd80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports